export var LOGO_COMMON_SIZE_CLASSNAMES = 'tw-w-10.4 tw-h-10.4';